exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modalCrearOC .ag-body-viewport .ag-pinned-left-cols-container,\n.modalCrearOC .ag-header .ag-pinned-left-header {\n  display: none;\n}\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n#modal-mantenedor-container\n  > div.cardnew\n  > div\n  > div\n  > div\n  > div\n  > div\n  > div\n  > div\n  > div\n  > div.ag-root-wrapper-body.ag-layout-auto-height\n  > div.ag-root.ag-unselectable.ag-layout-auto-height\n  > div.ag-body-horizontal-scroll\n  > div.ag-horizontal-left-spacer {\n  display: none !important;\n}\n", ""]);

// exports
